import React from "react";

function Environmental() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Environmental</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              This area of niche involves spotting out potential sources of environmental liability.  Clients are usually large corporations willing to establish factories and industries of that sort.  
              </p>
              <p>
              Part of our work is to carry out the due diligence to determine whether or not there are potential problems for such corporations and if so how to deal with them by essentially protecting the client.
              </p>
              <p>
              In the case of any environmental disputes we do and have in the past represented our clients.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Environmental;
